:host {
  display: block;
  --color: #ffffff;
  --color-tertiary: var(--Text-Tertiary, #767676);
  --border-radius: var(--sportsline-pick-card-header-border-radius, 0.5rem);
  --teams-background: var(--sl-teams-background);
  /* hardcoded for now until there is darkmode support */
  color: var(--color);
  --Utility-Icon-Primary: var(--color);
}

.sportsline-free-expert-pick-selection-header {
  border-radius: var(--border-radius);
  display: flex;
  padding: 0.75rem 1rem;
  gap: 1rem;
  position: relative;
  overflow: hidden;
  background: var(--teams-background);
}

.sportsline-free-expert-pick-selection-header--team-logos {
  --sportsline-team-logo-size: 8.875rem;
  position: absolute;
  top: -29px;
  left: calc(var(--sportsline-team-logo-size) / 2 * -1);
  right: calc(var(--sportsline-team-logo-size) / 3 * -1);
  display: flex;
  justify-content: space-between;
  opacity: 0.2;
}

.sportsline-free-expert-pick-selection-header--container {
  z-index: 1;
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 1rem;
}

.sportsline-free-expert-pick-selection-header--details {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.125rem;
}

.sportsline-free-expert-pick-selection-header--details-label {
  display: inline;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
}

.sportsline-free-expert-pick-selection-header--details-label__white {
  color: var(--color);
}

.sportsline-free-expert-pick-selection-header--details-odds {
  white-space: nowrap;
  padding-left: 0.5rem;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
}

.sportsline-free-expert-pick-selection-header--details-odds__white {
  color: var(--color-tertiary);
}

.sportsline-free-expert-pick-selection-header--details-sub-label {
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
}

.sportsline-free-expert-pick-selection-header--details-game-info {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.9;
  text-transform: uppercase;
}

.sportsline-free-expert-pick-selection-header--details-game-info,
.sportsline-free-expert-pick-selection-header--details-odds {
  opacity: 0.7;
}
